var UserInteractionStatus = {
  INJECTION: 'injection',
  DELIVERED: 'delivered',
  READ: 'read',
  INTERACTED: 'interacted',
  DECLINED: 'declined'
};
var Priority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
  UNRECOGNIZED: 'UNRECOGNIZED'
};
var Label = {
  SEE_MORE: 'See more',
  READ_MORE: 'Read More',
  READ_LESS: 'Read Less'
};

export { Label, Priority, UserInteractionStatus };
